// // Import the functions you need from the SDKs you need
// import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
// import { getAuth } from "firebase/auth";

// import { getFirestore } from "firebase/firestore";

// // TODO: Add SDKs for Firebase products that you want to use
// // https://firebase.google.com/docs/web/setup#available-libraries

// // Your web app's Firebase configuration
// // For Firebase JS SDK v7.20.0 and later, measurementId is optional
// const firebaseConfig = {
//   apiKey: "AIzaSyBXWYHnZ2viIZuvm96cIFfoznaGW5NsLDE",
//   authDomain: "kiddiekingdom-eada0.firebaseapp.com",
//   projectId: "kiddiekingdom-eada0",
//   storageBucket: "kiddiekingdom-eada0.firebasestorage.app",
//   messagingSenderId: "556739032616",
//   appId: "1:556739032616:web:36e189da6c95a6815ce71d",
//   measurementId: "G-0YW640JJD6",
// };

// const app = initializeApp(firebaseConfig);
// const auth = getAuth(app);
// const db = getFirestore(app);

// export { auth, db };
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// ⬇️ make sure this object is exported
export const firebaseConfig = {
  apiKey: "AIzaSyBXWYHnZ2viIZuvm96cIFfoznaGW5NsLDE",
  authDomain: "kiddiekingdom-eada0.firebaseapp.com",
  projectId: "kiddiekingdom-eada0",
  storageBucket: "kiddiekingdom-eada0.firebasestorage.app",
  messagingSenderId: "556739032616",
  appId: "1:556739032616:web:36e189da6c95a6815ce71d",
  measurementId: "G-0YW640JJD6",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
